module.exports = __webpack_public_path__ + "assets/img/img49.902349af.png";